import UIList from 'UIComponents/list/UIList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AsyncStatusType } from 'calling-lifecycle-internal/utils/types/AsyncData';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NextBestActions = ({
  nextBestActions,
  nextBestActionsLoadingStatus,
  refetchNextBestActions
}) => {
  const noNextBestActions = !nextBestActions || nextBestActions.length === 0;
  const hasFetchedNextBestActions = nextBestActionsLoadingStatus === AsyncStatusType.SUCCEEDED || nextBestActionsLoadingStatus === AsyncStatusType.FAILED;
  if (nextBestActionsLoadingStatus === AsyncStatusType.UNINITIALIZED) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h5", {
      style: {
        marginTop: '16px'
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "next-best-actions.header"
      })
    }), nextBestActionsLoadingStatus === AsyncStatusType.STARTED ? /*#__PURE__*/_jsx(UILoadingSpinner, {
      size: "xs",
      "data-test-id": "loading-spinner"
    }) : hasFetchedNextBestActions && noNextBestActions ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "next-best-actions.notFound_jsx",
      elements: {
        UILink
      },
      options: {
        onClick: () => refetchNextBestActions()
      }
    }) : hasFetchedNextBestActions && !noNextBestActions ? /*#__PURE__*/_jsx(UIList, {
      styled: true,
      childClassName: "m-bottom-3",
      children: nextBestActions.map((nextBestAction, index) => {
        return /*#__PURE__*/_jsx("span", {
          children: nextBestAction.description
        }, index);
      })
    }) : null]
  });
};
export default NextBestActions;